export default {
  title: 'Earn rewards when you make purchases',
}
